import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  OnInit,
} from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { SuperAdminService } from "src/app/super-admin.service";
import { ImagePreviewComponent } from "../../LR-management/image-preview/image-preview.component";
import { environment } from "src/environments/environment";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-vehicle-form",
  templateUrl: "./vehicle-form.component.html",
  styleUrls: ["./vehicle-form.component.css"],
})
export class VehicleFormComponent implements OnInit {
  @Input() mode: "add" | "edit" = "add";
  @Input() vehicleData: any = null;

  apiUrl = environment.domain;
  @ViewChild("showSlip") showSlip: ElementRef;

  /* ---------- DATA ---------- */
  vehicleTypesNames: string[] = [];
  DriverNames: string[] = [];
  transporterList: any[] = [];

  filteredVehicleTypes: Observable<string[]>;
  filteredDriverName: Observable<string[]>;
  filteredTransporterList: Observable<any[]>;

  /* ---------- PREVIEWS ---------- */
  permitPreview: any;
  rcPreview: any;
  insuracePreview: any;
  permit5yPreview: any;
  roadTexPreview: any;
  fitnessPreview: any;
  ownerpanPreview: any;
  owneradharPreview: any;
  cancelledChequePreview: any;

  slipURL: any;

  /* ---------- FILES ---------- */
  fieldsUploaded: any = {
    permit: null,
    RCCopy: null,
    insurance: null,
    permitYears: null,
    roadTax: null,
    fitness: null,
    ownerPancard: null,
    ownerAadharCard: null,
    cancelledCheque: null,
  };

  /* ---------- FORM ---------- */
  vehicleForm = new FormGroup({
    vehicleNumber: new FormControl("", Validators.required),
    vehicleType: new FormControl("", Validators.required),
    ownership: new FormControl(""),
    transporter: new FormControl(null),
    driverName: new FormControl(""),
    makerName: new FormControl(""),
    chassisNumber: new FormControl(""),
    engineNumber: new FormControl(""),
    permitNumber: new FormControl(""),
    policyNumber: new FormControl(""),
    city: new FormControl(""),
    permitDueDate: new FormControl(""),
    permitYearsDueDate: new FormControl(""),
    purchaseDate: new FormControl(""),
    roadTaxDate: new FormControl(""),
    insuranceDueDate: new FormControl(""),
    fitnessDueDate: new FormControl(""),
    pollutionExpiryDate: new FormControl(""),
  });

  constructor(
    private superAdminService: SuperAdminService,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get("id");

    if (id) {
      this.mode = "edit";
      this.getVehicleById(id);
    } else {
      this.mode = "add";
      this.vehicleForm.get("ownership")?.setValidators(Validators.required);
    }

    this.getVehicleType();
    this.getDriverName();
    this.getTransporters();
  }

  getVehicleById(id: string) {
    this.superAdminService.getparticlarVehicle(id).subscribe((res) => {
      if (res.status) {
        this.vehicleData = res.data[0];
        this.patchEditData();
      }
    });
  }

  /* ---------- EDIT PATCH ---------- */
  patchEditData() {
    const v = this.vehicleData;

    this.vehicleForm.patchValue({
      vehicleNumber: v.vehicle_no,
      vehicleType: v.type,
      ownership: v.ownership,
      transporter: v.transporter ?? null,
      driverName: v.driverName,
      makerName: v.makerName,
      chassisNumber: v.chassisNumber,
      engineNumber: v.engineNumber,
      permitNumber: v.permitNumber,
      policyNumber: v.policyNumber,
      city: v.city,
      permitDueDate: this.formatDate(v.permitDueDate),
      permitYearsDueDate: this.formatDate(v.permitYearsDueDate),
      purchaseDate: this.formatDate(v.purchaseDate),
      roadTaxDate: this.formatDate(v.roadTaxDate),
      insuranceDueDate: this.formatDate(v.insuranceDueDate),
      fitnessDueDate: this.formatDate(v.fitnessDueDate),
      pollutionExpiryDate: this.formatDate(v.pollutionExpiryDate),
    });

    // previews
    this.permitPreview = this.previewFromApi(v.permit);
    this.rcPreview = this.previewFromApi(v.RCCopy);
    this.insuracePreview = this.previewFromApi(v.insurance);
    this.permit5yPreview = this.previewFromApi(v.permitYears);
    this.roadTexPreview = this.previewFromApi(v.roadTax);
    this.fitnessPreview = this.previewFromApi(v.fitness);
    this.ownerpanPreview = this.previewFromApi(v.ownerPancard);
    this.owneradharPreview = this.previewFromApi(v.ownerAadharCard);
    this.cancelledChequePreview = this.previewFromApi(v.cancelledCheque);
  }

  previewFromApi(file: string) {
    if (!file) return null;

    const ext = file.split(".").pop()?.toLowerCase();

    const isPdf = ext === "pdf";

    return {
      url: `${this.apiUrl}/uploads/${file}`,
      type: isPdf ? "application/pdf" : "image/*",
      name: file,
    };
  }

  formatDate(date: any) {
    return date ? new Date(date).toISOString().split("T")[0] : "";
  }

  /* ---------- FILE UPLOAD ---------- */
  handleFileUpload(e: any, key: string, previewKey: string) {
    const file = e.target.files[0];
    if (!file) return;

    this.fieldsUploaded[key] = file;
    this[previewKey] = {
      url: URL.createObjectURL(file),
      type: file.type,
      name: file.name,
    };
  }

  /* ---------- SUBMIT ---------- */
  onSubmit() {
    if (this.vehicleForm.invalid) {
      console.log("INVALID FORM");
      return;
    }

    const payload: any = {
      ...this.vehicleForm.value,
      transporter: this.vehicleForm.value.transporter?._id ?? null,
    };

    if (this.mode === "edit" && this.vehicleData?._id) {
      payload._id = this.vehicleData._id;
    }

    const formData = new FormData();
    formData.append("myFormData", JSON.stringify(payload));

    const updatedFields = Object.keys(this.fieldsUploaded).filter(
      (k) => this.fieldsUploaded[k],
    );

    formData.append("updatedFields", JSON.stringify(updatedFields));

    updatedFields.forEach((key) => {
      formData.append("uploads[]", this.fieldsUploaded[key]);
    });

    this.mode === "add"
      ? this.addVehicle(formData)
      : this.updateVehicle(formData);
  }

  /* ---------- RESET ---------- */
  resetForm() {
    this.vehicleForm.reset();
    Object.keys(this.fieldsUploaded).forEach(
      (k) => (this.fieldsUploaded[k] = null),
    );
    this.permitPreview = this.rcPreview = this.insuracePreview = null;
    this.permit5yPreview = this.roadTexPreview = this.fitnessPreview = null;
    this.ownerpanPreview =
      this.owneradharPreview =
      this.cancelledChequePreview =
        null;
  }

  backTo() {
    window.history.back();
  }

  resetimg(key: string) {
    this.fieldsUploaded[key] = null;
    this[`${key}Preview`] = null;
  }

  /* ---------- DROPDOWNS ---------- */
  getVehicleType() {
    this.superAdminService.getVehicleType().subscribe((res) => {
      if (res.status) {
        this.vehicleTypesNames = res.data.map((v) => v.vehicletype_name);
        this.filteredVehicleTypes =
          this.vehicleForm.controls.vehicleType.valueChanges.pipe(
            startWith(""),
            map((v) =>
              this.vehicleTypesNames.filter((o) =>
                o.toLowerCase().includes((v || "").toLowerCase()),
              ),
            ),
          );
      }
    });
  }

  getDriverName() {
    this.superAdminService.getDriverName().subscribe((res) => {
      if (res.status) {
        this.DriverNames = res.data.map((d) => d.driver_name).filter(Boolean);
        this.filteredDriverName =
          this.vehicleForm.controls.driverName.valueChanges.pipe(
            startWith(""),
            map((v) =>
              this.DriverNames.filter((o) =>
                o.toLowerCase().includes((v || "").toLowerCase()),
              ),
            ),
          );
      }
    });
  }

  getTransporters() {
    this.superAdminService.getTransportersDropdownList().subscribe((res) => {
      if (res.status) {
        this.transporterList = res.data;
        this.filteredTransporterList =
          this.vehicleForm.controls.transporter.valueChanges.pipe(
            startWith(""),
            map((v) =>
              this.transporterList.filter((t) =>
                t.full_name.toLowerCase().includes((v || "").toLowerCase()),
              ),
            ),
          );
      }
    });
  }

  displayTransporter(t: any) {
    return t ? t.full_name : "";
  }

  onSelectTransporter(transporter: any) {
    this.vehicleForm.patchValue({
      transporter: transporter,
    });
  }

  fileChangeEventPermit(e: any) {
    this.handleFileUpload(e, "permit", "permitPreview");
  }

  fileChangeEventRC(e: any) {
    this.handleFileUpload(e, "RCCopy", "rcPreview");
  }

  fileChangeEventInsurance(e: any) {
    this.handleFileUpload(e, "insurance", "insuracePreview");
  }

  fileChangeEventPermitYears(e: any) {
    this.handleFileUpload(e, "permitYears", "permit5yPreview");
  }

  fileChangeEventRoadTax(e: any) {
    this.handleFileUpload(e, "roadTax", "roadTexPreview");
  }

  fileChangeEventFitness(e: any) {
    this.handleFileUpload(e, "fitness", "fitnessPreview");
  }

  fileChangeEventOwnerPancard(e: any) {
    this.handleFileUpload(e, "ownerPancard", "ownerpanPreview");
  }

  fileChangeEventOwnerAadharcard(e: any) {
    this.handleFileUpload(e, "ownerAadharCard", "owneradharPreview");
  }

  fileChangeEventCancelledCheque(e: any) {
    this.handleFileUpload(e, "cancelledCheque", "cancelledChequePreview");
  }

  addVehicle(formData: FormData) {
    this.superAdminService.addVehicle(formData).subscribe((res) => {
      if (res.status) {
        alert("Vehicle added successfully");
        window.history.back();
      }
    });
  }

  updateVehicle(formData: FormData) {
    this.superAdminService.updateVehicle(formData).subscribe((res) => {
      if (res.status) {
        alert("Vehicle updated successfully");
        window.history.back();
      }
    });
  }
}
